import { CurrencyPipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { TranslocoDirective } from '@jsverse/transloco';
import type { HelocDrawEligibilityEnum } from '@ld.consumer-portal/models';
import { BaseModalComponent } from '../base-modal/base-modal/base-modal.component';

export interface DrawFundsModalData {
  availableCredit: number;
  drawEligibilityStatus: HelocDrawEligibilityEnum;
  loanNumber: string;
  userId?: string;
  userFirstName?: string;
  userLastName?: string;
  userEmail?: string;
}

@Component({
  selector: 'ld-draw-funds-modal',
  imports: [BaseModalComponent, CurrencyPipe, TranslocoDirective],
  templateUrl: './draw-funds-modal.component.html',
  styleUrl: './draw-funds-modal.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DrawFundsModalComponent {
  readonly data = input.required<DrawFundsModalData>();

  readonly closeModal = output<void>();

  readonly drawSubmitted = output<void>();

  protected onClose(): void {
    this.closeModal.emit();
  }

  protected onSubmit(): void {
    this.drawSubmitted.emit();
    this.closeModal.emit();
  }
}
